export const CUSTOM_BL_CONTROL_ID = 'custom-bl-control';
